function centerVignette() {
  var scrollX = window.scrollX;
  var scrollY = window.scrollY;
  var image = document.querySelector('.layout-panel-flex > .group-block:nth-of-type(1) .image-block > img');
  var rect = image.getBoundingClientRect();
  var elLeft = rect.left + scrollX;
  var elTop = rect.top + scrollY;
  var cx = elLeft + rect.width * 0.5;
  var cy = elTop + rect.height * 0.5;

  var root = document.querySelector(':root');
  root.style.setProperty('--vignette-center', `${cx}px ${cy}px`)

  var main = document.querySelector('main');
  main.classList.add('show-gradient');
}

window.addEventListener("load", centerVignette);
window.addEventListener("resize", centerVignette);